import React from "react";
import styled from "styled-components";

const RadioGroupWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  &.delivery-address{
    display: grid;
    grid-template-columns: 1fr;
  }
  &.delivery-address label {
    margin-left: auto !important;
    margin-right: auto !important;
    min-width: 90%;
  }
  // @media (max-width: 425px) {
  //   &.delivery-address{
  //     grid-template-columns: 1fr;
  //   }
  // }
  // @media (min-width: 768px) and (max-width: 1024px){
  //   &.delivery-address{
  //     grid-template-columns: 1fr;
  //   }
  // }
`;

const RadioGroup = ({
  items = [],
  component,
  containerClassName,
  secondaryComponent,
}) => {
  return (
    <RadioGroupWrapper className={`radioGroup ${containerClassName}`.trim()}>
      {items.map((item, index) => component && component(item, index))}

      {secondaryComponent && secondaryComponent}
    </RadioGroupWrapper>
  );
};

export default RadioGroup;
